import { useEffect, useRef, useState } from "react";
import { useSearchParams } from "next/navigation";

function parseIds(param) {
  if (!param) return [];
  return param.split(",").map(Number).filter(Boolean);
}

export default function useFilterUrlSync({
  categories,
  services,
  setFilters,
  setCurrentPage,
  setSelectedCountry,
  setSearchTerm,
}) {
  const searchParams = useSearchParams();
  const hasAppliedRef = useRef(false);
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    if (hasAppliedRef.current) return;
    if (!categories.length && !services.length) return;

    const categoryIdsParam = searchParams.get("categories");
    const serviceIdsParam = searchParams.get("services");
    const countryParam = searchParams.get("country");
    const searchParam = searchParams.get("search");
    const cityParam = searchParams.get("city");
    const pageParam = searchParams.get("page");

    const categoryIds = parseIds(categoryIdsParam);
    const serviceIds = parseIds(serviceIdsParam);

    const validCategoryIds = categoryIds.filter(id =>
      categories.some(c => c.id === id)
    );

    const validServiceIds = serviceIds.filter(id =>
      [...categories, ...services].some(s => s.id === id)
    );

    hasAppliedRef.current = true;

    setFilters(prev => ({
      ...prev,
      categories: validCategoryIds,
      services: validServiceIds,
      city: cityParam || "All",
      search: searchParam || "",
    }));

    if (countryParam) setSelectedCountry(countryParam);
    if (searchParam) setSearchTerm(searchParam);
    if (pageParam && !isNaN(pageParam)) setCurrentPage(Number(pageParam));

    setIsReady(true);
  }, [categories, services]);

  return { isUrlApplied: isReady };
}
